export default "__VITE_ASSET__DQUn317h__";